module.exports = __webpack_public_path__ + "static/media/057-burundi.4dc402d8.svg";